import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Automation } from "./automation";
import { Action } from "./action";

export class AutomationAction extends Resource {
    public override type = 'automationActions';


    @prop()
    public automationId!: string;
    public automation!: Automation;
    
    @prop()
    public actionId!: string;
    public action!: Action;

    @prop()
    public config?: string = "";

    
    @prop()
    public actionConfig!: any;
    
}